export const NumberTrackingRptConstants ={
    GETALL_REQUEST: 'NumberTracking_GETALL_REQUEST',
    GETALL_SUCCESS: 'NumberTracking_GETALL_SUCCESS',
    GETALL_FAILURE: 'NumberTracking_GETALL_FAILURE'
}